// 自定义配置 方便项目开发

exports.devApiProxy = 'https://i-mf1-asia-east-public.poizon.net'

exports.head = {
  title: 'POIZON',
  meta: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content:
        'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover'
    },
    { name: 'apple-mobile-web-app-title', content: 'POIZON' },
    { name: 'wap-font-scale', content: 'no' },
    { name: 'msapplication-tap-highlight', content: 'no' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    { name: 'full-screen', content: 'yes' },
    { name: 'screen-orientation', content: 'portrait' },
    { name: 'x5-fullscreen', content: 'true' },
    { name: 'x5-orientation', content: 'portrait' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    {
      name: 'format-detection',
      content: 'telephone=no, email=no, address=no'
    },
    { name: 'theme-color', content: '#000000' },
    { name: 'share', content: 'POIZON' },
    { name: 'keywords', content: 'POIZON' },
    {
      hid: 'description',
      name: 'description',
      content: 'POIZON'
    },
    { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
    { 'http-equiv': 'x-dns-prefetch-control', content: 'on' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: 'POIZON' },
    { property: 'og:description', content: 'POIZON' }
  ],
  script: [
    {
      crossorigin: 'anonymous',
      defer: true,
      src: 'https://cdn.poizonapp.com/otel-trace/otel.min.js'
    }
  ],
  link: [
    {
      hid: 'icon',
      rel: 'icon',
      type: 'image/x-icon',
      href:
        'https://cdn.poizon.com/node-common/1ef8282aa5ac7c001c7ea8a8cd29c732.png'
    },
    {
      hid: 'shortcut icon',
      rel: 'shortcut icon',
      href:
        'https://cdn.poizon.com/node-common/1ef8282aa5ac7c001c7ea8a8cd29c732.png'
    },
    {
      hid: 'apple-touch-icon',
      rel: 'apple-touch-icon',
      href:
        'https://cdn.poizon.com/node-common/1ef8282aa5ac7c001c7ea8a8cd29c732.png'
    }
  ]
}

exports.postcss = {
  // 添加插件名称作为键，参数作为值
  plugins: {
    // 通过传递 false 来禁用插件
    'postcss-import': {},
    'postcss-url': {},
    'postcss-px-to-viewport': {
      viewportWidth: 750, // (Number) The width of the viewport.
      viewportHeight: 1334, // (Number) The height of the viewport.
      unitPrecision: 3, // (Number) The decimal numbers to allow the REM units to grow to.
      viewportUnit: 'vw', // (String) Expected units.
      selectorBlackList: ['.ignore', 'ignore-to-vw', '.hairlines'], // (Array) The selectors to ignore and leave as px.
      minPixelValue: 1, // (Number) Set the minimum pixel value to replace.
      mediaQuery: false // (Boolean) Allow px to be converted in media queries.
    },
    'postcss-aspect-ratio-mini': {},
    'postcss-preset-env': {
      autoprefixer: {
        add: true,
        grid: false
      }
    }
  }
}

exports.DEYI_DEFAULT_TEXT = '未找到对应的文案'
